import { fetchDataAndProceed } from '../../config/utils';
import { METHOD_TYPES } from '../../config/constants';

export const getAllIntents = (callback) => {
    return fetchDataAndProceed('/admin/v1/nlp/getAllIntents', METHOD_TYPES.GET, {}, callback);
};

export const getAllEntities = (callback) => {
    return fetchDataAndProceed('/admin/v1/nlp/entities', METHOD_TYPES.GET, {}, callback);
};

export const createUtterance = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/nlp/createUtterance', METHOD_TYPES.POST, data, callback);
};


// WEBPACK FOOTER //
// ./src/data/redux/nlp_details/api.js